<template>
  <!-- 资产列表 author: zhangxiaofeng -->
  <div class="product-list--main  flex" v-loading="loading">
    <!-- 左侧资产列表 -->
    <div class="left">
      <table>
        <thead>
          <tr>
            <td>
              <div class="asset-item f-cb">
                <a href="javascript: void(0);"
                   @click="checkAllAsset"
                   :class="[checkAll ? 'r2-icon-toggle_check_box' : 'r2-icon-toggle_check_box_outline_blank', disabledCheckAll ? 'disabled' : '']">
                </a>
                <label class="asset-name">资产编号</label>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(asset, idx) in list" :key="'asset-' + idx">
            <td>
              <div :class="['asset-item f-cb', activeAsset === asset.assetId ? 'active' : '']" @click.stop="showProducts(asset)">
                <a href="javascript: void(0);"
                   @click.stop="checkAsset(asset, idx)"
                   :class="[asset.checked ? 'r2-icon-toggle_check_box' : 'r2-icon-toggle_check_box_outline_blank', asset.disabled ? 'disabled' : '']">
                </a>
                <label class="asset-name">{{asset.assetNum}}</label>
                <span v-if="asset.disabled" class="status">
                  {{asset | formatStatus(popType)}}
                </span>
                <!--<i :class="['preview-icon r2-icon-action_find_in_page_outlined', activeAsset === asset.assetId ? 'active' : '']"></i>-->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 右侧 某个资产下的 产品列表 -->
    <div class="flex-1">
      <table>
        <thead>
          <tr>
            <td>
              <p class="flex package-instance t-head">
                <span class="w-419">
                  产品名称
                </span>
                <!--<span class="flex-1">开始时间 ~ 结束时间</span>-->
              </p>
            </td>
          </tr>
        </thead>
        <tbody :class="['product-list', !hasInstance && !hasPackage ? 'empty' : '']" :key="refreshPackageList">
          <!-- 树形菜单形状的 产品 -->
          <template v-if="hasPackage">
            <tr v-for="(treeItem, idx) in packageData.merchandiseInstanceList" :key="'tree-instance-' + idx">
              <td  class="product-item--wrapper children-list--cont">
                <package-list :list-data="treeItem" :level="1" :search-condition="searchCondition"></package-list>
                <div class="border-bottom"></div>
              </td>
            </tr>
          </template>

          <!-- 非 树形菜单形状的 产品 -->
          <template v-if="hasInstance">
            <tr v-for="(instanceItem, idx) in packageSort(packageData.productInstanceList, searchCondition)" :key="'package-instance-' + idx">
              <td class="product-item--wrapper">
                <!-- :border-top="idx === 0 && packageData.children && packageData.children.length" -->
                <package-instance :item="instanceItem" is-leaf :level="1" :search-condition="searchCondition">
                </package-instance>
              </td>
            </tr>
          </template>
          <tr v-if="list.length === 0">
            <td>
              <div class="font-14 text-align-center cursor-default" style="color: rgba(33, 37, 48, 0.35);line-height: 220px;padding-right: 213px;">
                没有查找到相关结果，请尝试其它产品名称进行搜索
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  .product-list--main{
    ul, p{ margin-bottom: 0; }
    font-size: 12px;
    .left{
      width: 25%;
      position: relative;
    }
    .flex1{
      position: relative;
    }
    table{
      display: block;
      width: 100%;
      tr{
        display: table;
        width: 100%;
        table-layout: fixed;
      }
      a{
        &:link{
          color: #555;
        }
        &.r2-icon-toggle_check_box{
          &.disabled{
            &:link{
              color: gray;
              cursor: not-allowed;
            }
          }
          &:link{
            color: #1f8aee;
          }
        }
      }
      thead{
        background: #F3F4F7;
        border-bottom: 1px solid rgba(33, 37, 48, 0.15);
        font-weight: 600;
        color: rgba(33, 37, 48, 0.8);
        padding: 5px;
        min-height: 35px;
        width: 100%;
        td{
          text-align: left;
          .asset-item{
            font-size: 14px;
            border-bottom: none;
          }
        }
      }
      tbody{
        height: 230px;
        overflow-y: auto;
        position: relative;
        display: block;
        tr{
          td{
            padding: 0 5px;
            .asset-item{
              font-size: 14px;
              padding: 4px 0;
              cursor: pointer;
              .asset-name{
                color: rgba(33, 37, 48, 0.8);
                cursor: pointer;
              }
              &:hover, &.active{
                color: #2079fa;
                .asset-name{
                  color: #2079fa;
                }
              }
            }
          }
          &:first-child{
            td{
              .asset-item{
                margin-top: 5px;
              }
            }
          }
        }
        // 每个资产对应的产品列表 表格
        &.product-list{
          border: 1px solid #e6e6e6;
          &.empty{
            border: none;
          }
          border-top: none;
          tr{
            /* 树形结构 所在行 有底部边线 */
            .children-list-cont{
              position: relative;
              .border-bottom{
                width: 100%;
                height: 1px;
                background-color: #e6e6e6;
                position: absolute;
                bottom: 0;
                z-index: 10;
              }
            }
            td{ padding: 0; }
            &:first-child{
              td{
                padding-top: 5px;
              }
            }
            &:last-child{
              p.instance{
                border-bottom: none;
              }
            }
          }
        }
        .product-item--wrapper{
          &>.package-tree{
            display: block;
          }
        }
      }
      td{
        padding: 5px;
        line-height: 25px;
        .asset-item{
          line-height: 25px;
          border-bottom: 1px solid #e6e6e6;
          position: relative;
          &>*{
            float: left;
            display: inline-block;
            margin-left: 4px;
            &:first-child{
              margin-left: 0;
            }
          }
          .status{
            display: inline-block;
            text-align: center;
            padding: 2px 3px;
            border-radius: 10px;
            background-color: #2079fa;
            color: #fff;
            line-height: 16px;
            margin-top: 2px;
            width: 36px;
            font-size: 12px;
            box-sizing: border-box;
          }
          .preview-icon{
            cursor: pointer;
            font-size: 26px;
            position: absolute;
            right: -5px;
          }
        }
      }
    }
  }
</style>
<script>
import PackageList from './PackageList'
import PackageInstance from './PackageInstance'
import {clone} from '@/assets/utils'
import manageService from 'service/manage'
import {mapState} from 'vuex'
import Bus from '@/assets/utils/bus'

export default {
  name: 'AssetProductList',
  props: {
    popType: { // 弹窗类型
      type: String,
      default: 'Asset'
    },
    configItem: { // 正在操作的行数据(用户信息)
      type: Object,
      default: () => {}
    },
    assetList: { // 资产列表
      type: Array,
      default: () => []
    },
    searchCondition: { // 产品名称过滤条件
      type: Array,
      default: () => []
    },
    addAsset: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [],
      checkedBefore: {}, // 操作前 已经选择的资产(已分配给他的资产 或 已借出的资产)
      packageData: {}, // 资产下对应的产品包
      refreshPackageList: 0,
      selfAssetCount: 0, // 已配置给该用户的资产数
      checkAll: false, // 是否全选 所有资源
      disabledCheckAll: false, // 禁用全选
      activeAsset: '' // 右侧产品列表 将展示此资产下的产品
    }
  },
  computed: {
    // 有产品包 树形结构
    hasPackage () {
      return this.packageData.merchandiseInstanceList && this.packageData.merchandiseInstanceList.length > 0
    },
    // 有产品
    hasInstance () {
      return this.packageData.productInstanceList && this.packageData.productInstanceList.length > 0
    },
    ...mapState({
      searchBy: state => state.members.searchBy
    })
  },
  filters: {
    // 1.0 资产使用状态
    formatStatus (item, popType) {
      let str = ''
      if (item.onlineFlag) {
        str = '联网'
      } else if (item.borrowedFlag) {
        if (popType === 'Lent') {
          str = '已借出'
        } else {
          str = '借出'
        }
      }
      return str
    }
  },
  watch: {
    assetList (value) {
      if (value.length) {
        this.initData()
      } else {
        this.list = []
        this.activeAsset = ''
        this.packageData = {}
        // this.addAsset = []
        // this.deleteAsset = []
        // this.checkedBefore = {}
        this.refreshPackageList++
      }
    }
  },
  mounted () {
    this.checkedBefore = {}
    this.initData()
    if (this.popType === 'Asset') {
      Bus.$on('updateCheckedBefore', (checkedAfter) => {
        this.checkedBefore = checkedAfter
      })
    }
  },
  methods: {
    // 产品名称排序，命中搜索条件的显示最前面
    packageSort (items = [], searchCondition = []) {
      if (!Array.isArray(searchCondition) || searchCondition.length === 0) {
        return items
      }
      const containSearchCondition = []
      const packages = []
      for (let i = 0; i < items.length; i++) {
        if (this.searchCondition.includes(items[i].productName)) {
          containSearchCondition.push(items[i])
        } else {
          packages.push(items[i])
        }
      }
      return containSearchCondition.concat(packages)
    },
    // 1. 初始化资产数据
    initData () {
      // this.list = []
      this.selfAssetCount = 0
      const list = []
      this.assetList.forEach((asset) => {
        const item = clone(Object.assign(asset, {
          checked: (asset.gldUserId === this.configItem.gldUserId) || this.addAsset.includes(asset.assetNum),
          disabled: asset.borrowedFlag || asset.onlineFlag
        }))
        if (this.popType === 'Lent') {
          // 设置借出 时 只展示配置给他的资产
          if (item.checked) {
            item.checked = item.borrowedFlag
            list.push(item)
            // this.$set(this.list, this.list.length, item)
            if (item.borrowedFlag) {
              this.checkedBefore[item.assetId] = item.assetNum
            }
          }
        } else {
          // 配置资产 显示所有资产
          if (item.checked || !item.gldUserId) {
            list.push(item)
            // this.$set(this.list, this.list.length, item)
            if (item.checked) {
              this.checkedBefore[item.assetId] = item.assetNum
              this.selfAssetCount++
            }
          }
        }
      })
      this.list = list
      if (this.searchBy === 'getAssetList') {
        this.$emit('listReady', {selfAsset: this.selfAssetCount, leftoverAsset: list.length - this.selfAssetCount, checkedBefore: this.checkedBefore})
      }
      if (list.length) {
        this.showProducts(this.list[0])
        this.judgeCheckAll()
      }
    },
    // 2. 获取某个资产下对应的产品包
    showProducts (asset) {
      if (this.popType === 'Asset') {
        this.sentLog(100117028)
      }
      if (this.activeAsset === asset.assetId) return
      this.activeAsset = asset.assetId
      this.packageData = {}
      this.refreshPackageList++
      manageService.getPackagesByAsset({assetId: asset.assetId}).then((data) => {
        // console.log(data)
        if (+data.code === 200) {
          this.packageData = data.data // require('@/assets/js/testData/packages.js').default
        } else {
          this.packageData = {}
        }
        this.refreshPackageList++
      }).catch((e) => {
        this.packageData = {}
        this.refreshPackageList++
        console.log(e)
      })
    },
    // 3.1 选择某个资产
    checkAsset (asset, idx) {
      if (asset.disabled) return
      this.$set(this.list, idx, Object.assign(asset, {checked: !asset.checked}))
      const count = this.judgeCheckAll()
      const {list, checkedBefore} = this
      if (this.popType === 'Asset') {
        this.sentLog(100117029, {count})
      }
      this.$emit('checkedChange', {list, checkedBefore})
    },
    // 3.2 全选 / 取消全选
    checkAllAsset () {
      if (this.disabledCheckAll) return
      this.checkAll = !this.checkAll
      let count = 0
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].disabled) {
          if (this.checkAll) {
            count++
          }
          this.$set(this.list, i, Object.assign(this.list[i], {checked: this.checkAll}))
        }
      }
      const {list, checkedBefore} = this
      if (this.popType === 'Asset') {
        this.sentLog(100117029, {count})
      }
      this.$emit('checkedChange', {list, checkedBefore})
    },
    // 3.3 判断是否 已全选
    judgeCheckAll () {
      let checkLen = 0
      let disabledLen = 0
      this.list.forEach((asset) => {
        if (asset.checked) { checkLen++ }
        if (asset.disabled) { disabledLen++ }
      })
      this.disabledCheckAll = (disabledLen === this.list.length)
      this.checkAll = (checkLen > 0 && checkLen === this.list.length)
      return checkLen
    }
  },
  components: {
    PackageList,
    PackageInstance
  }
}
</script>
